import { createAnyCable } from './cable/createAnyCable';
import * as connectionActions from '../state/modules/connection/actions';

export const createWebsocketListener = ({
  dispatch,
  connectHandler,
  receivedHandler,
  retryHandler,
  cleanupHandler,
  fallbackPoller,
  fallbackPollerInterval
}) => {
  let poller = null;
  let disconnectTime = null;
  let hasConnectedOnce = false;

  // a disconnection should wait at least this long before we are going to call
  // the API
  const MIN_DISCONNECT_TIME_BEFORE_API_CALL = 60 * 1000;

  // Wait between MIN and MAX seconds before making API call
  const MIN_WAIT_TIME_BEFORE_API_CALL = 30 * 1000;
  const MAX_WAIT_TIME_BEFORE_API_CALL = 120 * 1000;

  const WAIT_TIME_BEFORE_POLLING_START = 15 * 1000;

  return {
    connected: () => {
      connectHandler && connectHandler();
      hasConnectedOnce = true;
      dispatch(connectionActions.connected());

      if (poller) {
        // reconnected: cancel polling and get fresh data
        clearInterval(poller);
        // if disconnected for more than 60 seconds, fire off an API call
        if (Date.now() - disconnectTime > MIN_DISCONNECT_TIME_BEFORE_API_CALL) {
          // avoid thundering herd: randomly wait between 30 and 120 seconds
          setTimeout(
            fallbackPoller,
            MIN_WAIT_TIME_BEFORE_API_CALL +
              (MAX_WAIT_TIME_BEFORE_API_CALL - MIN_WAIT_TIME_BEFORE_API_CALL) * Math.random()
          );
        } else {
          console.log('Disconnected time too short. Not calling API');
        }
      }
    },
    disconnected: () => {
      if (fallbackPoller) {
        disconnectTime = Date.now();
        const delayedFallbackPoller = () => {
          // wait before making the first polling call
          if (Date.now() - disconnectTime > WAIT_TIME_BEFORE_POLLING_START) {
            fallbackPoller();
          }
        };
        poller = setInterval(delayedFallbackPoller, fallbackPollerInterval);
      }
      dispatch(connectionActions.disconnected());

      cleanupHandler && cleanupHandler();

      // If no subscription has been established yet, we need to retry.
      // If the subscription was established before, but then disconnected, we will
      // rely on the ping-pong mechanism to detect disconnections potentially refresh the page.
      if (!hasConnectedOnce) {
        console.log('[ActionCable] Failed to register, probably due to a timeout. Retrying in 5 seconds...');
        setTimeout(() => {
          retryHandler && dispatch(retryHandler());
        }, 5000); // Wait 5 seconds before trying to subscribe again
      }
    },
    received: data => {
      if (data === 'PING') return;
      dispatch(connectionActions.connected());

      // actionCable backwards compat. For unknown reasons, when AnyCable is
      // installed, the old ActionCable clients get duplicate messages, one with
      // a slightly different format
      if (data.stream && data.data) {
        return;
      }

      receivedHandler && receivedHandler(data);
    }
  };
};

export const createActionCable = token => {
  console.deviceLogInfo('Creating AnyCable consumer');
  return createAnyCable(token);
};

export default createActionCable;
